import { useModule } from '@/use/modules';
import useRouter from '@/use/router';

export default (context, name, module) => {
    try {
        return useModule({
            router: useRouter,
        })(context, { name, module });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Use manager for module error: ${name}\n${e.toString()}`);
    }
};
